module.exports = __webpack_public_path__ + "assets/img/s1_tab1_active_m.2a7badcb.png";